// extracted by mini-css-extract-plugin
export default {"Revision":"Revision_Revision__cwQ53","Content":"Revision_Content__UEyiR","List":"Revision_List__TNkRv"};